const getters = {
  faqs: state => state.faq,
  faq: state => state.faq_id,
  faq_categorys: state => state.faq_category,
  faq_category: state => state.faq_category_id,
};

export default getters;
